import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.consent = document.getElementById("consent")
    if (!this.consent) return

    this.resizeObserver = new ResizeObserver(() => this.#reposition())

    // Vue mounts into #consent and swaps its children, so re-grab the live
    // <user-consent> whenever the subtree or its [hidden] attribute changes.
    this.mutationObserver = new MutationObserver(() => this.#track())
    this.mutationObserver.observe(this.consent, { childList: true, subtree: true, attributes: true })

    this.#track()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.mutationObserver?.disconnect()
    this.element.style.bottom = ""
  }

  #track() {
    const banner = this.consent.querySelector("user-consent")
    if (banner && banner !== this.banner) {
      this.resizeObserver.disconnect()
      this.banner = banner
      this.resizeObserver.observe(banner)
    }
    this.#reposition()
  }

  #reposition() {
    const height = this.banner?.offsetHeight ?? 0
    console.log("action-bar bottom:", height)
    this.element.style.bottom = `${height}px`
  }
}
